import { React, useState, useEffect } from "react";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { Button } from "@mui/material";
// import "./ShowChalan.css";
import { setChalanDetail } from "../../storeSlices/chalanSlice";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import Printewayform from "../Printewayform";
import { setBiltyDetail } from "../../storeSlices/biltySlice";
// import { setlocalChalanDetail } from "../../storeSlices/localChalanSlice";
// import Printchallanrasid from "./PrintChalanRasid";
const style2 = {
  position: "absolute",
  height: "100%",
  overflow: "scroll",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 800,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
};
function ShowEwayForms({ eway }) {
  const [open2, setOpen2] = useState(false);

  useEffect(() => {
    console.log("useEffect hasbeen called");
  }, [open2]);
  // function changeCss() {
  //   document.getElementById("biltyform").classList.toggle("c-form");
  //   document.getElementById("bilty-template").classList.toggle("jadu");
  // }
  const handleClose2 = () => {
    setOpen2(false);
    console.log("open2  from handleclose: ", open2);
  };
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const printBilty = (eway) => {
    setOpen2(true);
    console.log("propss : ", eway);
  };

  return (
    <div className="ch-bx">
      <div className="chLeftInfo">
        <h2>Eway-no ⇝ {eway?.eWay_Bill_No}</h2>
        {/* <h2>Generated date ⇝ {eway?.ewayBillDate}</h2> */}
      </div>
      <div className="chRightBtns">
        {/* <button onClick={() => editChallan(bilty)}>Edit</button> */}
        <Button onClick={() => printBilty(eway)}>Print</Button>
      </div>
      <Modal
        open={open2}
        onClose={handleClose2}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style2}>
          {/* <Printchallanrasid chalan={challan} handleClose2={handleClose2} /> */}
          <Printewayform eway={eway} handleClose2={handleClose2} />
        </Box>
      </Modal>
    </div>
  );
}

export default ShowEwayForms;
